import * as React from "react";
import { SVGProps, Ref, forwardRef } from "react";
function SvgVkAlt(props: SVGProps<SVGSVGElement>, ref: Ref<SVGSVGElement>) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="1.5em"
      height="1.5em"
      fill="none"
      viewBox="0 0 32 32"
      ref={ref}
      {...props}
    >
      <path
        fill="currentColor"
        fillRule="evenodd"
        d="M2.24942 2.24942C0 4.49884 0 8.11923 0 15.36V16.64C0 23.8808 0 27.5012 2.24942 29.7506C4.49884 32 8.11923 32 15.36 32H16.64C23.8808 32 27.5012 32 29.7506 29.7506C32 27.5012 32 23.8808 32 16.64V15.36C32 8.11923 32 4.49884 29.7506 2.24942C27.5012 0 23.8808 0 16.64 0H15.36C8.11923 0 4.49884 0 2.24942 2.24942ZM5.40007 9.7334C5.5734 18.0534 9.73336 23.0534 17.0267 23.0534H17.4401V18.2934C20.1201 18.56 22.1466 20.5201 22.96 23.0534H26.7467C25.7067 19.2667 22.9733 17.1734 21.2666 16.3734C22.9733 15.3867 25.3733 12.9867 25.9466 9.7334H22.5065C21.7598 12.3734 19.5468 14.7734 17.4401 15V9.7334H14V18.96C11.8667 18.4267 9.17339 15.8401 9.05339 9.7334H5.40007Z"
        clipRule="evenodd"
      />
    </svg>
  );
}
const ForwardRef = forwardRef(SvgVkAlt);
export default ForwardRef;
ForwardRef.defaultProps = {
  "aria-hidden": true,
  focusable: "false",
  role: "img",
};
